import { deleteKeySdk } from "@/services/sdk";
import { useDisclosure } from "@nextui-org/react";
import { useState } from "react";
import { toast } from "react-toastify";

const useDelete = () => {
  const [loading, setLoading] = useState(false);
  const [currentKey, setCurrentKey] = useState<null | string>(null);
  const { onClose, onOpen, onOpenChange, isOpen } = useDisclosure();

  const onOpenDelete = (key: string) => {
    setCurrentKey(key);
    onOpen();
  }

  const handleDelete = async (callback: () => void) => {
    if (!currentKey) return toast.warning("Not found current key");
    try {
      setLoading(true);
      await deleteKeySdk(currentKey);
      toast.success('Deleted successfully!')
      callback();
      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return {
    onCloseDelete: onClose,
    onOpenDelete,
    onOpenChangeDelete: onOpenChange,
    isOpenDelete: isOpen,
    loading,
    handleDelete
  }
}

export default useDelete;